import React from 'react';
import {StarIcon as FilledStarIcon} from "@heroicons/react/solid";
import {StarIcon as EmptyStarIcon} from "@heroicons/react/outline";

// Types ----

type StarProps = {
  filled?: boolean
}

// Component ----

function Star({filled}: StarProps) {

  const className = "h-3 text-yellow-500";

  return filled? <FilledStarIcon className={className}/> : <EmptyStarIcon className={className}/>
}

// Export ----

export default Star;